module.exports = __webpack_public_path__ + "media/country_flags/cc-46f77464.png";